import React from "react";
import "../styles/About.css";
import Resume from "./Resume";
import { FaBriefcase } from "react-icons/fa";

export default function About() {
  const timelineData = [
    {
      year: "Mar 2019 - Dec 2022",
      title: "Staff Assistant cum Cashier Gr-3",
      company: "People's Leasing & Finance PLC",
      logo: "/images/plc.png",
      desc: "Worked with employees in branches to build customer relationship in various roles.",
    },
    {
      year: "June 2025 - Dec 2025",
      title: "Business Analyst & UI/UX Engineer",
      company: "Navicode.cloud",
      logo: "/images/navicode.png",
      desc: "Worked at Navicode.cloud, bridging business goals with user experience design.",
    },
    {
      year: "June 2025 - Dec 2025",
      title: "Front-end Developer",
      company: "Navicode.cloud",
      logo: "/images/navicode.png",
      desc: "Worked at Navicode.cloud, built responsive, user-centric web interfaces.",
    },
    {
      year: "January 2026 - Present",
      title: "Trainee Full-stack Developer",
      company: "Don Bosco Info Tech, Jaffna",
      logo: "/images/dbit_jaffna.png",
      desc: "Learned to built responsive, user-centric web interfaces with front-end and back-end technologies.",
    },
  ];

  return (
    <section id="about" className="about">
     
      <div className="about-header">
        <h2>About Me</h2>
        <p>A unique blend of analytical thinking and creative design expertise</p>
      </div>

   
      <div className="timeline-section">
        <h3 className="timeline-title">
          <FaBriefcase className="icon" /> Career Timeline
        </h3>

        <div className="timeline-vertical">
          {timelineData.map((item, index) => (
            <div key={index} className="timeline-card">
              <div className="timeline-dot"></div>
              <div className="timeline-line"></div>

              <div className="timeline-info">
                <div className="timeline-header">
                  <img
                    src={item.logo}
                    alt={item.company}
                    className="company-logo"
                  />

                  <div className="timeline-text">
                    <span className="timeline-year">{item.year}</span>
                    <h4>{item.title}</h4>
                    <span className="timeline-company">{item.company}</span>
                  </div>
                </div>

                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      
      <Resume />
    </section>
  );
}
